/**
 * GlobalModals - Renders modals that should appear anywhere in the app
 * 
 * Currently handles:
 * - Pending trainer invites (shows after client signs in from any page)
 */
import { useAuth } from '@/core/AuthContext';
import { PendingTrainerInvite } from './PendingTrainerInvite';

export function GlobalModals() {
  const {
    user,
    userData,
    pendingTrainerInvites,
    pendingTrainerInvitesLoading,
    acceptPendingTrainerInvite,
    declinePendingTrainerInvite,
  } = useAuth();

  // Only show for authenticated clients (not trainers)
  // Don't show during initial loading
  const shouldShow = 
    user && 
    userData && 
    userData.role === 'client' && 
    !pendingTrainerInvitesLoading && 
    pendingTrainerInvites.length > 0;

  if (!shouldShow) {
    return null;
  }

  return (
    <PendingTrainerInvite
      invites={pendingTrainerInvites}
      isLoading={pendingTrainerInvitesLoading}
      onAccept={acceptPendingTrainerInvite}
      onDecline={declinePendingTrainerInvite}
    />
  );
}
